import React from 'react'
import MyTable from '../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../../../UI/table/MyTableNotFound'
import SupplyBillItemShort from './SupplyBillItemShort'

const SupplyBillItemsTableShort = ({ supplyBillItems }) => {
  return (
    <MyTable
        head={
            <>
                {/* <TableCell align="center"></TableCell> */}
                <TableCell align="center">№</TableCell>
                <TableCell align="center">Назва</TableCell>
                <TableCell align="center">Кількість</TableCell>
                <TableCell align="center">Вартість, з ПДВ</TableCell>
                {/* <TableCell align="center">Посилання</TableCell> */}
                {/* <TableCell align="center">Погодження</TableCell> */}
                {/* <TableCell align="center">Отримано?</TableCell> */}
                {/* <TableCell align="center">Дії</TableCell> */}
            </>
        }
        body={
            // supplyOrderItems && supplyOrderItems.length > 0 ?
            //     supplyOrderItems.map((supplyOrderItem, index) => 
            supplyBillItems && supplyBillItems.length > 0 ?
                supplyBillItems.map((supplyBillItem, index) => 
                    <SupplyBillItemShort
                        key={supplyBillItem.id}
                        index={index}
                        supplyBillItem={supplyBillItem} 
                        // checked={checked}
                        // setChecked={setChecked}
                    />
                )
            : 
                <MyTableNotFound
                    text='Позицій не знайдено' 
                    // columns={6}
                />
        }
        name='позицій'
        hidePagination={true}
    />
  )
}

export default SupplyBillItemsTableShort